import { mapGetters } from 'vuex';

export default {
    name: 'dspTitle',
    inject: ['$eventBus'],
    computed: {
        ...mapGetters('glb', ['glb']),
        ...mapGetters('dsp', ['dsp']),
        getRatings(){
            return this.dsp.stateRating ? (this.dsp.stateRating.stateRating || 0) : 0;
        }
    }
};